import React, { Component } from 'react';
import { Container } from 'reactstrap';
import Layout from '../components/Layout';
import PageForm from '../modules/PageForm';

class NewBasicPage extends Component {
  getConfig = () => {
    const { state } = this.props.location;
    if (!state) {
      return undefined;
    } else {
      return state;
    }
  };

  getInitialValues = () => {
    const initialValues = { headerImageLarge: {} };
    const { state } = this.props.location;
    if (!state) {
      return initialValues;
    } else {
      return { ...initialValues, lang: state.lang };
    }
  };

  render() {
    return (
      <Layout>
        <Container>
          <h1>Nová základní stránka</h1>
          <PageForm
            config={this.getConfig()}
            initialValues={this.getInitialValues()}
          />
        </Container>
      </Layout>
    );
  }
}

export default NewBasicPage;



// WEBPACK FOOTER //
// ./src/pages/NewBasicPage.js